<template>
    <div>
        <create-variable-card card-type="dashboard" />
        <create-formula-card
            :show_sensor_depth_selection="true"
            :show_soil_type_selection="true"
            formula-target="dashboard"
        />
        <formula-list-table :show_sensor_depth_selection="true" formula-target="dashboard" />
    </div>
</template>

<script>
import FormulaListTable from "@/components/formula-table/FormulaListTable";
import CreateVariablesCard from "../../../components/calculation-table/CreateVariablesCard";
import CreateFormulaCard from "@/components/formula-table/CreateFormulaCard";
import { mapActions, mapState } from "vuex";

export default {
    name: "DashboardFormulaView",
    components: {
        "create-variable-card": CreateVariablesCard,
        "create-formula-card": CreateFormulaCard,
        "formula-list-table": FormulaListTable
    },
    computed: {
        ...mapState("formula", ["colors", "formulaTargets"])
    },
    methods: {
        ...mapActions("formula", ["fetchFormulaColors", "fetchFormulaTargets", "fetchAllFormulas"]),
        ...mapActions("soil", ["fetchSoilTypesList"]),
        ...mapActions("country", ["fetchCountries"])
    },
    async beforeMount() {
        await this.fetchFormulaTargets("dashboard");
        !this.colors.length && (await this.fetchFormulaColors());
        await this.fetchSoilTypesList();
        await this.fetchCountries();
    },
    async mounted() {
        await this.fetchAllFormulas("dashboard");
    }
};
</script>

<style scoped></style>
